import React from 'react';
import { getDateOnlyString } from 'src/utils/date';

type Props = {
  value: Date | string | undefined;
};

/**
 * Some date values are not sent as `Date` objects, but strings. This component converts and displays this correctly.
 * For use with DataTableV3.
 * @param {string} [value] - The value to be converted and displayed.
 * @returns JSX component displaying date
 */
export const DateCell = ({ value }: Props) => {
  if (value) {
    const date = new Date(value);
    if (date) {
      const string = getDateOnlyString(date, '.');

      return <span>{string}</span>;
    }
  }

  return <></>;
};
